import React, { useEffect, useState } from 'react';
export function StickyFooter() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      // Show sticky footer after scrolling down 500px
      if (window.pageYOffset > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 w-full bg-white border-t border-slate-200 shadow-[0_-10px_30px_rgba(0,0,0,0.1)] z-50 animate-fade-in-up" data-id="element-128">
      <div className="container mx-auto px-4 py-4" data-id="element-129">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 max-w-5xl mx-auto" data-id="element-130">
          <div className="text-center sm:text-left hidden md:block" data-id="element-131">
            <p className="text-slate-600 font-medium text-sm" data-id="element-132">
              Recuperá la alegría de los pequeños momentos.
            </p>
            <p className="text-slate-900 font-black text-xl" data-id="element-133">$19.990 ARS</p>
          </div>

          <a href="https://pagos.auradigital.fun/cart/48207923118180:1" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-brand-500 hover:bg-brand-600 text-white font-bold py-3 px-8 rounded-xl shadow-lg shadow-brand-500/30 transition-all hover:scale-105 active:scale-95 text-center whitespace-nowrap" data-id="element-134">
            SI, QUIERO LA OFERTA AHORA
          </a>
        </div>
      </div>
    </div>;
}